import { Icon } from '../components/Icon';
import { HERO, HERO_STATS } from '../content/site';

export function Hero() {
  return (
    <section id="top" className="relative overflow-hidden bg-aurora-soft">
      {/* Decorative aurora blooms — purely cosmetic */}
      <div aria-hidden className="pointer-events-none absolute -left-24 -top-24 h-72 w-72 rounded-full bg-primary-300/40 blur-3xl" />
      <div aria-hidden className="pointer-events-none absolute -right-16 top-24 h-64 w-64 rounded-full bg-accent-400/30 blur-3xl" />

      <div className="container-content relative grid items-center gap-12 py-20 md:py-28 lg:grid-cols-[1.1fr_0.9fr]">
        <div className="animate-fade-up">
          <span className="eyebrow">{HERO.eyebrow}</span>
          <h1 className="mt-5 font-heading text-4xl font-extrabold leading-tight text-ink-900 sm:text-5xl lg:text-6xl">
            Turn your product into a{' '}
            <span className="text-aurora">guaranteed prize campaign.</span>
          </h1>
          <p className="mt-6 max-w-xl text-lg leading-relaxed text-ink-700">{HERO.subcopy}</p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <a href={HERO.primaryCta.href} className="btn-warm">
              {HERO.primaryCta.label}
              <Icon name="arrow-right" className="h-5 w-5" />
            </a>
            <a href={HERO.secondaryCta.href} className="btn-secondary">
              {HERO.secondaryCta.label}
            </a>
          </div>

          <p className="mt-6 flex items-start gap-2 text-sm text-ink-500">
            <Icon name="shield" className="mt-0.5 h-5 w-5 shrink-0 text-primary-600" />
            <span>{HERO.trustLine}</span>
          </p>
        </div>

        {/* Stat card cluster */}
        <div className="animate-fade-up rounded-3xl border border-line bg-white/80 p-6 shadow-card backdrop-blur sm:p-8">
          <p className="font-heading text-sm font-semibold uppercase tracking-wider text-primary-700">
            Every campaign includes
          </p>
          <ul className="mt-5 space-y-4">
            {HERO_STATS.map((stat) => (
              <li key={stat.label} className="flex items-baseline gap-3">
                <span className="font-heading text-2xl font-bold text-ink-900">{stat.value}</span>
                <span className="text-sm text-ink-500">{stat.label}</span>
              </li>
            ))}
          </ul>
          <div className="mt-6 rounded-2xl bg-aurora-soft p-4">
            <p className="flex items-center gap-2 text-sm font-medium text-ink-700">
              <Icon name="qr" className="h-5 w-5 text-primary-700" />
              Co-branded competition page, QR + tracked links, winner content and a campaign report.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;
